import { render, staticRenderFns } from "./MySurnameField.vue?vue&type=template&id=067f2d2d"
import script from "./MySurnameField.vue?vue&type=script&lang=js"
export * from "./MySurnameField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports